import { Dialog } from '@equinor/eds-core-react';
import { styled } from 'styled-components';
import { theme } from '../../../tokens/theme';

export const IniParamDialog = styled(Dialog)`
  display: flex;
  flex-direction: column;
  width: min(720px, 75vw);

  table {
    width: 100%;
    border: 1px solid ${theme.light.ui.background.medium};
    border-collapse: collapse;
  }
`;

export const IniDialogContent = styled(Dialog.CustomContent)`
  height: 40vh;
`;
